$(document).ready(function(){
 
  // Show the PDF container on catalogue click
  $('.catalogue-column .multicolumn-card__image-wrapper').on('click', function(){
    $('.pdf-container').show();
  })

  // Hide the PDF container on close
  $('.close').on('click', function(){
      $(this).parent().hide();
  })

  /* 
    Check if the user is on a mobile device
  */
  function isMobileDevice() {
    return /Mobile|iPhone|iPad|Android|Windows Phone|BlackBerry|Opera Mini/i.test(navigator.userAgent);
  }
  
  // Set the product colors containers placement on archive page
  // Set the product colors containers placement on archive page
  var card_prod_height = $('.grid__item .card__media').height();
  var inner_item_height = document.querySelector('.grid__item .card__inner');
  if(inner_item_height != null){
    inner_item_height = inner_item_height.offsetHeight-40;
  }
  card_prod_height = card_prod_height - 40;
  
  
  // Replace '.grid__item' with the actual class name or ID you're targeting
  var gridItem = document.querySelector('.grid__item');
  
  if (gridItem) {
    var card_prod_height = $('.grid__item .card__media').height();

    if ( isMobileDevice() || window.innerWidth < 500) {
        card_prod_height = card_prod_height;
        console.log(inner_item_height);
        
        var elements = document.querySelectorAll('.version-two-color');
        elements.forEach(function(element) {
          element.setAttribute('style', "top:"+inner_item_height+'px !important;');
        });

      console.log('MOBILE');
    } else {
        
      $('.version-two-color').css('top', inner_item_height+'px');

      console.log('BIG DEVICE');
    }
  }

  // Changes the product color/url/price after click on archive
  setTimeout(() => {
    $('.color-selection.collection a img, .color-selection.collection .color_swatch').on('click', function(){
      console.log('CHANGE URL');
      var prodUrl = jQuery(this).attr('data-url');
      var prodImage = jQuery(this).attr('data-img');
      var newPrice = $(this).attr('data-price');
      var oldPrice = $(this).attr('data-old-price');
      newPrice = parseFloat(newPrice).toFixed(2);
      oldPrice = parseFloat(oldPrice).toFixed(2);
      
      $(this).parents('.custom__grid').find('.product-link').attr( 'href', $(this).data('url') );
      $(this).parents('.custom__grid').find('.rimage-wrapper .rimage__iamge').attr( 'src', $(this).data('img') );
      $(this).parents('.custom__grid').find('.rimage-wrapper .rimage__iamge').attr( 'srcset', $(this).data('img') );
      
      $(this).parent().parent().find('a.selected').removeClass('selected');
      $(this).parent().addClass('selected');
      
      $(this).parents('.custom__grid').find('.product-price').html('<span class="price-item price-item--old">'+oldPrice+' kr</span>');
      $(this).parents('.custom__grid').find('.product-price').html('<span class="price-item price-item--regular">'+newPrice+' kr</span>');
    });
  }, 1200);
  

  // Render the products colors on collection page
  //render_reference_products();
  get_current_collection_sold_out_prodcuts();
});
  
// Function that renders the product colors on the collection page 
function render_reference_products(){
  console.log('Info: Render product');
  // var product_handle_objects = get_reference_products();

  $('.custom__grid').each(function(){
    var colorContainer = $(this).find('.color-selection');
    var main_id = $(colorContainer).attr('data-main-id');
    var selected_handle = $(colorContainer).attr('data-selected-handle');
    var color_version = $(colorContainer).attr('data-color-version-two');
    var check_offer_collection = $(this).get(0).hasAttribute('data-offer-collection') ? $(this).attr('data-offer-collection') : "no-offer";
    var check_offer_number = $(this).get(0).hasAttribute('data-offer-number') ? parseInt( $(this).attr('data-offer-number') ) : 0;
    
    var handleArr = [];
    handleArr.length = 0;
    handleArr.push($(colorContainer).attr('data-selected-handle')+'|'+$(colorContainer).attr('data-related-handles') );
    
    if( handleArr == null ){
      console.log('Info: No products in stored data');
      return;
    }else{
      console.log('Info: Reindexing products');
      //jQuery(colorContainer).html('');
    }

    var splitCookie = handleArr[0].split('|');
    var list = jQuery(colorContainer);
    var productArr = [];
    productArr.length = 0;
    // Get normal productinfo
    for( i = 0; i < splitCookie.length; i++ ){
      var url = '/products/'+splitCookie[i]+'.js';

      jQuery.getJSON(url, function(product) {
        productArr.push(product);
      })
      .done(function(product) {
        console.log( "Success" );
        
      })
      .fail(function() {
        //console.log( "error: No handle found" );
      });

    }

    setTimeout(() => {
      if( productArr.length == 0 ){
          console.log('Info: No products in stored data');
          return;
      }else{
          console.log('Info: Reindexing products');
      }
      
      productArr.forEach(element => {
        // Check tags to see what color the product is.
        // This will need to be dynamic in the future, when PIM is in engish
        for( var tag of element.tags ){
          if( tag.toLowerCase().indexOf('bicolor') > 0 || tag == 'Metal_Bicolor' || tag == 'Bicolor'){
            var color_image =  color_version ? 'linear-gradient(54deg, rgba(214,214,214,1) 49%, rgba(216,200,151,1) 49%)' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_bicolor.png';
            var color_group = 'cw_bicolor';
            break;
          }
          if(tag.toLowerCase().indexOf('sølv') > 0 ||  tag == 'Metal_Sterlingsølv' || tag == 'Sterlingsølv' || tag.toLowerCase().indexOf('silber') > 0){
            var color_image =  color_version ? '#d6d6d6' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_silver.png';
            var color_group = 'cw_silver';
            break;
          }
          if( tag.toLowerCase().indexOf('Rosa ') > 0 ||  tag == 'Metal_Rosa' || tag == 'Rosa' || tag == 'Rosaforgyldt' || tag.toLowerCase().indexOf('rosa') > 0){
            var color_image =  color_version ? '#f1d2c5' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_rosa.png';
            var color_group = 'cw_rosa';
            break;
          }
          if( tag.toLowerCase().indexOf('forgyldt') > 0 ||  tag == 'Metal_Forgyldt' || tag == 'Forgyldt' || tag.toLowerCase().indexOf('vergoldet') > 0){
            var color_image =  color_version ? '#d8c897' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_gold.png';
            var color_group = 'cw_gold';
            break;
          }
          
          if(tag.toLowerCase().indexOf('Ruthenium') > 0 ||  tag == 'Metal_Rutheniumbelagt' || tag == 'Rutheniumbelagt'){
            var color_image =  color_version ? '#666' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_black.png';
            var color_group = 'cw_black';
            break;
          }
        }
        var featured_image = element.featured_image;
        var flip_image = element.images[1];
        var is_selected = 'not-selected';

        // Set class for selected element
        if(element.handle == selected_handle){
          var is_selected = 'selected';
        }

        // Check if the product is on sale and create a new price if true
        if( check_offer_number != 0 ){
          var saved_amount = (element.price/100)*check_offer_number;
          var element_price = (element.price-saved_amount);
          var old_price = element.price.toFixed(2)/100;
          element_price = element_price.toFixed(2)/100;
        }else{
          var element_price = element.price.toFixed(2)/100;;
        }

        // Refresh html element
        html = '';
        if( color_version ){
          if( typeof(color_image) == 'undefined' ){
            color_image = '#d6d6d6';
          }

          html +=
          ' <a href="javascript:void(0)" class="js-class js-item '+is_selected+'">'+
              '<div '+'style="background:'+color_image+';" color="'+color_image+'" class="color_swatch fittingbox-select" data-frame="{{ product_frame }}"'+ 
              'data-id="'+element.id+'" data-main-id="'+main_id+'"'+
              'data-title="'+element.title+'" data-url="/products/'+element.handle+'" data-old-price="'+old_price+'" data-price="'+element_price+'"'+
              'data-max-price="'+element.price_max+'" data-img="'+featured_image+'" data-flip-img="'+flip_image+'"'+
              'data-color-group="'+color_group+'" data-selected-handle="'+element.handle+'">'+
              '</div>'+
          '</a>';
        }else{
          html +=
          ' <a href="javascript:void(0)" class="js-class js-item '+is_selected+'">'+
              '<img '+'src="'+color_image+'" class="color_swatch fittingbox-select" data-frame="{{ product_frame }}"'+ 
              'data-id="'+element.id+'" data-main-id="'+main_id+'"'+
              'data-title="'+element.title+'" data-url="/products/'+element.handle+'" data-old-price="'+old_price+'" data-price="'+element_price+'"'+
              'data-max-price="'+element.price_max+'" data-img="'+featured_image+'" data-flip-img="'+flip_image+'"'+
              'data-color-group="'+color_group+'" data-selected-handle="'+element.handle+'"'+
              '/>'+
          '</a>';
        }
        
        i++;
        $(list).append(html);
      });
    }, 900);
  });
}

// Function that retrieves the current collection sold out productsz
function get_current_collection_sold_out_prodcuts(){
  if( $('#sold-out-collection').length > 0){
    setTimeout(() => {
      
      // Get url parameters to check page number
      const queryString         = window.location.search;
      const urlParams           = new URLSearchParams(queryString);
      const page_param          = urlParams.get('page')
      const sold_out_container  = document.querySelector("#sold-out-collection");
      const max_page            = sold_out_container.dataset.pagesize; 
      const offer_collection    = "";
      const offer_number        = 50;
      

      // Check if we are on the last page og pagination
      if( page_param == max_page || max_page == 1 ){
        // Call the function with the collection handle and API access token
        getProductsInCollection(location.pathname, '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')
        .then(products => {
          // Loop through the array of products and do something with each one
          var html      = "";
          for (let i = 0; i < products.length; i++) {
            // Assign the individual product
            const product = products[i];
            var splash    = "";
            
            // Get the text for the splashes
            if ( product.tags.includes("4 mm") && product.product_type == "Charms" ) {
              splash = '<div data-first-splash="true" class="grid-product__tag grid-product__tag--plus-size first-splash splash-design-round" style="background-color:#a3a1a1; color: #ffffff;font-size:12px; ">'+
              '<p>Til slimlæder &amp; <br>sølvarmbånd</p>'+
              '</div>';
            }
            if ( product.tags.includes("6 mm") && product.product_type == "Charms" ) {
              splash = '<div data-second-splash="true" class="grid-product__tag grid-product__tag--second-tag second-splash splash-design-round move-down" style="background-color:#000000; color: #ffffff;font-size:12px;  ">'+
              '<p>Til Classic <br>læderarmbånd</p>'+
              '</div>';
              
            }
            
            // Check if the product is available
            for (let n = 0; n < product.variants.length; n++) {
              const variant = product.variants[n];
              if( product.product_type == "Ringe"){
                continue;
              }
              if (variant.available == false ) {
                html += '<div data-product-id="'+product.category+'" class="product-block custom__grid" data-handle="'+product.handle+'">'+
                  '<div class="block-inner">'+
                    '<div class="block-inner-inner">'+
                      '<div class="image-cont">'+
                        splash+
                        '<a href="/products/'+product.handle+'" class="product-link">'+
                          '<div class="image-label-wrap">'+
                            '<div class="product-label-container">'+
                              '<span class="product-label product-label--stock">'+
                                '<span>'+
                                  'Udsolgt'+
                                '</span>'+
                              '</span>'+
                              '<span class="product-label product-label--sale label--sold-out">'+
                                '<span>'+
                                  'Få besked når produktet er på lager'+
                                '</span>'+
                              '</span>'+
                            '</div>'+
                            '<img src="'+product.images[0].src+'" alt="You and Me Charms til sølvarmbånd - CHRISTINA" class="motion-reduce main-image" width="2000" height="2000">'+
                          '</div>'+
                        '</a>'+
                      '</div>'+
                      '<div class="product-info">'+
                        '<div class="inner">'+
                          '<div class="innerer">'+
                            '<a href="/products/'+product.handle+'" class="product-link">'+
                              '<div class="product-block__title">'+
                                product.title+
                              '</div>'+
                              '<div class="product-price">'+
                              '<span class="product-price__item product-price__amount  theme-money">'+
                                variant.price+
                              '</span>'+
                              '</div>'+
                            '</a>'+
                          '</div>'+
                        '</div>'+
                      '</div>'+
                    '</div>'+
                  '</div>'+
                '</div>';
              }
            }
          }
          $(sold_out_container).append(html);
        })
        .catch(error => console.error(error));
      }
    }, 500);
  }
}

/**
 * Recursive funtion to get all products in a current collection
 * @param {*string} collectionHandle 
 * @param {*string} accessToken 
 * @param {*array} products 
 * @param {*Int} page 
 * @returns 
 */
function getProductsInCollection(collectionHandle, accessToken, products = [], page = 1) {
  return fetch(`${collectionHandle}/products.json?limit=50&page=${page}&access_token=${accessToken}`)
  .then(response => response.json())
  .then(productsPage => {
    // Concatenate the new products with the previous ones
    products = products.concat(productsPage.products);

    // Check if there are more products available
    if (productsPage.products.length === 50) {
      // Recursively call the function to get the next page of products
      return getProductsInCollection(collectionHandle, accessToken, products, page + 1);
    } else {
      // Return the final list of products when there are no more pages
      return products;
    }
  })
  .catch(error => console.error(error));
}

/**
 * Returns data in a specific collection
 * @param {*String} access_token 
 * @param {*String} domain 
 * @param {*String} product_handle 
 */
function return_product_collection(access_token, domain, product_handle){
  console.log('gettings collections');
  const client = ShopifyBuy.buildClient({
    storefrontAccessToken: access_token,
    domain: domain
  });
  
  client.product.fetchByHandle(product_handle).then(product => {
    const collectionEdges = product.collections.edges;
    const collections = collectionEdges.map(edge => edge.node);

  }).catch(error => console.error(error));
}

$('.iframe-full-height').on('load', function(){
  this.style.height=this.contentDocument.body.scrollHeight +'px';
});

/**
 * Function to get metafild values
 * @param {*string} handle 
 * @param {*string} namespace 
 * @param {*string} key 
*/
function get_metafield_value(handle, namespace, key) {
  const url = "https://christina-b2b.myshopify.com/api/2022-01/graphql.json";
  const storefrontAccessToken = 'cfe2d8c03c4b734d24842840b632f1de';
  const query = `
  {
    productByHandle(handle: "${handle}") {
      title
      metafield(namespace: "${namespace}", key: "${key}") {
        value
      }
    }
  }
  `;

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: query
  })
  .then(response => response.json())
  .then(data => {
      const metafieldValue = data.data.productByHandle.metafield.value;
      return metafieldValue;
  });
}

/**
 * Controls the inventory data  
 * @param {*string} value 
 */
function product_inventory_functionality(value) {

  // The container which hold the initial data
  // like {{product.handle}}, {{product.id}} etc
  const element_data = document.querySelector('.option-selectors');
  
  if (!element_data) return;

  let default_variant = element_data.getAttribute('data-only-default') === 'true';
  const initial_id = element_data.getAttribute('data-id');
  const parent_handle = element_data.getAttribute('data-product-handle');
  
  if (typeof value === "undefined") {
    default_variant = true;
  }

  // Fetch the product data - Check for variant values
  fetch(`/products/${parent_handle}.js`)
  .then(response => response.json())
  .then(product => {
    let variant_id;
    
    if (!default_variant) {
      const variant = product.variants.find(v =>
        v.option1 === value || 
        v.option2 === value || 
        v.option3 === value
      );
      
      if (variant) {
        variant_id = variant.id;
      }
    } else {
      variant_id = initial_id;
    }

    var klaviyo_btn = document.querySelector('.variant-klaviyo-btn');
    if(klaviyo_btn){
      if (check_stock_status(product.id, variant_id) == false) {
        console.log("in stock ${fa}");
        klaviyo_btn.style.display = "block";
      }else{
        klaviyo_btn.style.display = "none";
        
      }
    } 
      
      
  })
  .catch(error => console.error('Error fetching product:', error));
}


/**
 * Check stock status 
 * THis does not work unless commented script below is present on product page
 * @param {*string} productId 
 * @param {*string} variantId 
 * @returns true if in stock
 */
function check_stock_status(productId, variantId) {
  console.log('Inside check');
  if (window.inventories[productId] && window.inventories[productId][variantId]) {
      const quantity = window.inventories[productId][variantId].quantity;
      console.log('Quantity: '+ quantity);
      console.log(quantity > 0);
      return quantity > 0;
  }
  return false;
}

  // // Store inventory quantities in JS because they're no longer
  // // available directly in JS API when a variant changes.
  // // We make an object to hold all necessay data
  // window.inventories = window.inventories || {};
  // window.inventories['{{ product.id }}'] = {};
  // {% for variant in variants_with_inventory_tracking %}
  //   window.inventories['{{ product.id }}'][{{ variant.id }}] = {
  //     'quantity': {{ variant.inventory_quantity | default: 0 }},
  //     'policy': '{{ variant.inventory_policy | default: false }}',
  //     'incoming': '{{ variant.incoming | default: false }}',
  //     'next_incoming_date': {{ variant.next_incoming_date | date: format: 'date' | json }}
  //   };
  // {% endfor %}

/**
 * Output inventorydata
 * @param {*string} productId 
 * @param {*string} variantId 
 */
function display_inventory_data(productId, variantId) {
  if (window.inventories[productId] && window.inventories[productId][variantId]) {
      const inventory = window.inventories[productId][variantId];
      console.log("Quantity:", inventory.quantity);
      console.log("Policy:", inventory.policy);
      console.log("Incoming:", inventory.incoming);
      console.log("Next Incoming Date:", inventory.next_incoming_date);
  } else {
      console.log("No inventory data found for the specified product and variant.");
  }
}



